// src/constants/status.js
export const STATUS = {
  SCHEDULED: 'scheduled',
  ACTIVE: 'active',
  AWAITING_VERIFICATION: 'awaiting_verification',
  READY_FOR_PAYOUT: 'ready_for_payout',
  PAID: 'paid',
  CANCELED: 'canceled',
};